module.exports = __webpack_public_path__ + "img/logo-wht-01.16a4e1f1.svg";